<div class="centralizer">
  <div class="container">
    <div class="version-text">
      <a title="Versão do App: {{ version }}"><span>OTW</span>onco v{{ version }}</a>
    </div>
    <div class="btns-container">
      <app-button type="secondary" class="btn" text="Imprimir" [disabled]="true">
      </app-button>
      <div class="vertical-line"></div>

      @if(!medicalRecordIsOpen){
      <app-button type="secondary" class="new" text="Novo Atendimento" (click)="startNewMedicalRecord()"
        [disabled]="loading() || isSomeMedicalTabLoading() || isPatientDead()">
      </app-button>

      <app-button type="secondary" class="btn" (buttonEvent)="closeMedicalRecord()"
        [disabled]="loading() || isSomeMedicalTabLoading() || isPatientDead()" text="Fechar Prontuário">
      </app-button>
      }
      @else if (medicalRecordIsOpen){
      <app-button type="secondary" class="btn" text="Descartar Atendimento"
        [disabled]="loading() || isSomeMedicalTabLoading() || isPatientDead()"
        (buttonEvent)="cancelMedicalRecordChanges()">
      </app-button>
      <app-button type="secondary" class="btn" text="Finalizar Atendimento"
        [disabled]="loading() || isSomeMedicalTabLoading()  || isPatientDead()" (buttonEvent)="save()">
      </app-button>
      }

    </div>
  </div>
</div>